export default __webpack_public_path__ + "static/media/imone-icon.5104889e.webp";